
import { SearchResult } from "@/types/inventory";
import { performTraditionalSearch } from "../api/inventoryApi";
import { createInitialState } from "./eventHandlers";
import { setupSSEConnection } from "./connectionManager";

export const streamInventoryData = async (
  searchTerm: string, 
  onUpdate: (result: SearchResult) => void,
  onComplete: (finalResult: SearchResult) => void
): Promise<void> => {
  console.log(`🔍 [DEBUG] Starting search for: "${searchTerm}"`);
  
  // Initialize stream state
  const state = createInitialState(searchTerm);
  
  // Fallback function for traditional search
  const fallbackToTraditionalSearch = async () => {
    try {
      const result = await performTraditionalSearch(searchTerm);
      onUpdate(result);
      onComplete(result);
    } catch (error) {
      console.error("💥 [DEBUG] Both SSE and traditional search failed:", error);
      onComplete(state.currentResult);
      throw error;
    }
  };
  
  try {
    // Setup SSE connection with all event handlers
    setupSSEConnection({
      searchTerm,
      state,
      onUpdate,
      onComplete,
      onFallback: fallbackToTraditionalSearch
    });
    
  } catch (error) {
    console.error("💥 [DEBUG] Error setting up SSE, falling back to traditional search:", error);
    await fallbackToTraditionalSearch();
  }
};
